import Cookies from 'universal-cookie';
import { NextApiRequest, NextApiResponse } from 'next';

import { JWT_COOKIE_KEY } from '@/constants/constantsAckoDrive';
import { CookieService } from './auth/cookie-service';
import { IncomingMessage } from 'http';
import { AUTH_KEYS } from '@/constants/common';
import { getHeaderString } from '@/utils/common';
// import ServerCookies from "cookies";
// import Cookies as ServerCookies from "universal-cookie";

export const authenticationService = {
    isLoggedIn,
    isLoggedInServerBrowser,
    validateAuthHeaders,
};

function isLoggedIn() {
    const cookieService = new CookieService();
    const access_token = cookieService.getAccessToken();
    const refresh_token = cookieService.getRefreshToken();
    if (access_token == '' && refresh_token == '') return false;
    return true; // User might be authenticated
}

// async function isAbsolutelyLoggedIn() {
//   if (typeof window !== "undefined") {
//     if (!isLoggedIn())
//       // Early exist - tokens are not present in the cookies
//       return false;
//     const cookies = new Cookies();
//     let actual_tokens = cookies.get(JWT_COOKIE_KEY) || {};
//     let access_token = actual_tokens["access"] || "";
//     let refresh_token = actual_tokens["refresh"] || "";
//     try {
//       // Verifying the access token
//       await AuthService.verifyToken(access_token);
//     } catch (err) {
//       // Access token might be invalid
//       // Trying to validated Refresh token
//       try {
//         await AuthService.verifyToken(refresh_token);
//       } catch (err2) {
//         // access and refresh tokens are both invalid
//         return false;
//       }
//     }
//     // Either access token or else refresh token or both are valid
//     return true;
//   } else {
//     // Server side, considering the user is logged in, authentication will be taken care of at the client side
//     return true;
//   }
// }

function isLoggedInServerBrowser(req: IncomingMessage, res: any) {
    if (typeof window !== 'undefined') {
        const cookies = new Cookies();
        let actual_tokens = cookies.get(JWT_COOKIE_KEY) || {};
        let access_token = actual_tokens['access'] || '';
        let refresh_token = actual_tokens['refresh'] || '';
        if (access_token == '' && refresh_token == '')
            // Early return
            return false;
        return true; // User might be authenticated
    } else {
        // const cookies = new ServerCookies(req, res);
        const cookies = new Cookies(req.headers.cookie);
        let actual_tokens = cookies.get(JWT_COOKIE_KEY) || null;
        if (!actual_tokens) return false;
        return true; // User might be authenticated
    }
}

function validateAuthHeaders(
    req: NextApiRequest,
    res: NextApiResponse
): boolean {
    const userId = getHeaderString(req.headers[AUTH_KEYS.X_USER_ID]);
    const authUserId = getHeaderString(req.headers[AUTH_KEYS.X_AUTH_USER_ID]);
    if (!userId && !authUserId) {
        return false;
    }
    return true;
}
